// Migrated to Polaris Web Components
import React, { useState, useEffect } from 'react';
import { MetaobjectDefinitions } from '../Services/MetaobjectService';
import { getShopUrl } from '../Services/CommonServices';
import { Definitions } from '../Services/DefinitionService';

const MappingModal = ({ active, setActive, shopifyHeaders, catalogHeaders, setTypeSelected, mapModalLodaing, setMappedHeaders, setFormSubmit, currentRoute, blockUpload }) => {
  var storeUrl = getShopUrl();
  const initializeMappings = () => {
    return shopifyHeaders.reduce((acc, shopifyHeader) => {
      const matchedHeader = catalogHeaders.find(
        (catHeader) => catHeader.toLowerCase() === shopifyHeader.toLowerCase()
      );
      acc[shopifyHeader] = matchedHeader || null;
      return acc;
    }, {});
  };

  const [headerMappings, setHeaderMappings] = useState(initializeMappings);

  // Define required fields based on the current route
  const getRequiredFields = () => {
    if (currentRoute === "metaobject") {
      return ["Handle"]; // Only Handle is required for metaobjects
    }
    // Add other routes and their required fields if needed
    return [];
  };

  const handleMappingChange = (value, header) => {
    setFormSubmit(false);
    setHeaderMappings((prevMappings) => ({
      ...prevMappings,
      [header]: value,
    }));
  };

  const handleAutoMap = () => {
    setFormSubmit(false);
    setHeaderMappings(initializeMappings());
  };



  const handleClearAllMappings = () => {
    setHeaderMappings(
      shopifyHeaders.reduce((acc, header) => {
        acc[header] = null; // Reset mappings
        return acc;
      }, {})
    );
  };

  const handleSubmit = () => {
    setMappedHeaders(headerMappings);
    setFormSubmit(true);
    setActive(false);
  };

  // Validation helper - only required fields for each route type
  const isSubmitDisabled = () => {
    if (!headerMappings) return true;

    // For definition imports, only validate required fields
    // if (currentRoute === "metaobject") {
    //   const requiredFields = ["handle"];
    //   return requiredFields.some(field => !headerMappings[field]);
    // }

    // For metaobject imports, only validate required fields
    if (currentRoute === "metaobject_definition") {
      const requiredFields = ["type", "name","displayNameKey"];
      return requiredFields.some(field => !headerMappings[field]);
    }

    // For metafield imports, only validate required fields
    if (currentRoute === "metafield_definition") {
      const requiredFields = ["key", "name", "namespace", "ownerType", "type"];
      return requiredFields.some(field => !headerMappings[field]);
    }

    // For other routes (product, order, etc.), validate all mappings
    return Object.values(headerMappings).some((value) => value === null);
  };

  const [selectedType, setSelectedType] = useState("");
  // const [definitionResourceType, setDefinitionResourceType] = useState("");
  const [metaobjectDefinitions, setMetaobjectDefinitions] = useState([]);
  const [definitionOwnerTypes, setDefinitionOwnerTypes] = useState([]);

  // Handle modal visibility with Web Components pattern
  useEffect(() => {
    const modal = document.getElementById('mapping-modal');
    if (modal) {
      if (active && modal.showOverlay) {
        modal.showOverlay();
      } else if (!active && modal.hideOverlay) {
        modal.hideOverlay();
      }
    }
  }, [active]);

  useEffect(() => {
    if (currentRoute === "metaobject" && !blockUpload) { QueryMetaobjectDefinitions(); }
    if (currentRoute === "metafield_definition" && !blockUpload) { QueryOwnerTypes(); }
  }, []);

  useEffect(() => {
    handleAutoMap();
  }, [shopifyHeaders, catalogHeaders]);

  function QueryMetaobjectDefinitions() {
    setFormSubmit(false);
    try {
      MetaobjectDefinitions(storeUrl).then(function (result) {
        if (result !== null) {
          setSelectedType(result[0]?.type);
          setMetaobjectDefinitions(result);

        }
      });
    }
    catch (error) {
      console.error(error);
    }
  }

  function QueryOwnerTypes() {
    setFormSubmit(false);
    try {
      Definitions(storeUrl, "metafield").then(function (result) {
        if (result !== null) {
          setSelectedType(result[0]?.type);
          setDefinitionOwnerTypes(result);

        }
      });
    }
    catch (error) {
      console.error(error);
    }
  }

  return (
    <s-modal
      id="mapping-modal"
      heading="Map Column Headers to Shopify Fields"
      size="large"
      padding="none"
    >
      {/* <s-box padding="none"> */}
        <s-stack gap="base">

          {(currentRoute === "metaobject" || currentRoute === "metafield_definition") && (
            <>

              {(currentRoute === "metafield_definition" || currentRoute === "metaobject") && (
                <s-box padding="base">
                <s-select
                  label={currentRoute !== "metafield_definition"  && currentRoute !== "metaobject_definition" ? "Type" : "Owner Type"}
                  value={selectedType}
                  onChange={(e) => { setSelectedType(e.currentTarget.value); setTypeSelected(e.currentTarget.value); }}
                >
                  {currentRoute !== "metafield_definition" && currentRoute !== "metaobject_definition"
                    ? metaobjectDefinitions.map((option) => (
                      <s-option key={option.type} value={option.type}>{option.type}</s-option>
                    ))
                    : definitionOwnerTypes.map((option) => (
                      <s-option key={option} value={option}>{option}</s-option>
                    ))
                  }
                </s-select>
                </s-box>
              )}
            </>
          )}

          <s-box padding="base">
            <s-stack direction="inline" gap="base" alignment="start">
              <s-button onClick={handleAutoMap}>Auto-Map</s-button>
              <s-button onClick={handleClearAllMappings}>Clear All</s-button>
            </s-stack>
          </s-box>

          {mapModalLodaing ? (
            <s-box padding="base">
              <s-stack alignment="center">
                <s-spinner size="large" />
              </s-stack>
            </s-box>
          ) : (
            <s-table padding="none">
              <s-table-header-row>
                <s-table-header>Shopify Header</s-table-header>
                <s-table-header>Catalog Header</s-table-header>
              </s-table-header-row>
              <s-table-body>
                {shopifyHeaders?.map((header, index) => {
                  // Determine required fields based on route type
                  let isRequired = false;
                  
                  if (currentRoute === "metaobject") {
                    isRequired = [ "handle"].includes(header);
                  } else if (currentRoute === "metaobject_definition") {
                    isRequired = ["type", "name"].includes(header);
                  } else if (currentRoute === "metafield_definition") {
                    isRequired = ["key", "name", "namespace", "ownerType", "type"].includes(header);
                  } else {
                    // For other routes (product, order, etc.), all fields are required
                    isRequired = true;
                  }

                  return (
                    <s-table-row key={index}>
                      <s-table-cell>
                        <s-text type="strong">
                          {header}
                          {isRequired && (
                            <s-text variant="error"> *</s-text>
                          )}
                        </s-text>
                      </s-table-cell>
                      <s-table-cell>
                        <s-select
                          value={headerMappings[header] || ''}
                          onChange={(e) => handleMappingChange(e.currentTarget.value || null, header)}
                        >
                          <s-option value="">Select a value</s-option>
                          {catalogHeaders.map((catHeader) => (
                            <s-option key={catHeader} value={catHeader}>{catHeader}</s-option>
                          ))}
                        </s-select>
                      </s-table-cell>
                    </s-table-row>
                  );
                })}
              </s-table-body>
            </s-table>
          )}
        </s-stack>
      {/* </s-box> */}

      {/* Submit and Cancel buttons - Cancel next to Submit */}
      <s-button
        slot="secondary-actions"
        onClick={() => setActive(false)}
        commandFor="mapping-modal"
        command="--hide"
      >
        Cancel
      </s-button>

      <s-button
        slot="primary-action"
        variant="primary"
        onClick={handleSubmit}
        disabled={isSubmitDisabled()}
        commandFor="mapping-modal"
        command="--hide"
      >
        Submit
      </s-button>
    </s-modal>
  );
};



export default MappingModal;
